module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_hospital06-0f78d3d3f90add756b10a2b11ccc2b88.png";